export default __webpack_public_path__ + "static/media/what-we-do.76ca359c.jpg";